import { ScheduleSelectType } from '../../../hooks/schedule';
import { useRefCallback } from '@bydesign-ui/hooks';
import React, { useCallback } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { HoverTrigger } from '../../popover/components/HoverTrigger';
export function ScheduleViewItem(props) {
  var selectType = props.selectType,
      disabled = props.disabled,
      onClick = props.onClick,
      label = props.label,
      value = props.value,
      style = props.style;
  var cls = usePrefixCls('schedule-view-item', {
    select: selectType === ScheduleSelectType.SELECTED,
    disabled: disabled
  });
  var onClickCallback = useRefCallback(onClick);
  var handleClick = useCallback(function () {
    if (disabled) {
      return;
    }

    onClickCallback([{
      label: label,
      value: [value]
    }]);
  }, [label, value, disabled]);
  return React.createElement(HoverTrigger, {
    data: props,
    className: cls,
    onClick: handleClick,
    style: style
  });
}